/// <summary name='cafm.auth' type='Object'>Container object for CAFM authentication code</summary>
cafm.auth = {
    /// <field name='authenticated' type='Boolean'>Flag to determine if the user is authenticated, from outside cafm.auth please use cafm.auth.isAuthenticated instead</field>
    authenticated: false,
    /// <field name='loginAction' type='cafm.actions.Action'>The forms login action</field>
    loginAction: function () {

        return new cafm.actions.Action({
            id: 'CAFMLogin',
            description: 'CAFM Login',
            elementId: 'loginForm',
            validationMessage: cafm.res.str.AuthMessageInvalidLogin,
            loaderSelector: '#signIn',
            url: cafm.url.api('Login/Authenticate'),
            beforeSend: function (r) {

                // ensure touch cookie value is cleared/added as appropriate
                cafm.dom.clearCookie(cafm.res.consts.Cookie_CafmModule);
                if (cafm.browsers.isTouchAble()) {
                    let data = {};
                    data[cafm.res.consts.Cookie_CafmTouch] = true;
                    cafm.dom.setCookie({ data });
                }
            },
            statusCodeFuncs: {
                200: function (r, s, m, a) {

                    switch (r.AuthInfo.Status) {

                        case cafm.enums.LoginStatus.Success:

                            cafm.auth.setAuthenticationInfo(r.AuthInfo, isDefined(cafm.auth.loginRedirectUrl), a.values.Persist);

                                cafm.actions.execute({
                                    url: cafm.url.api('TimeZone/GetList'),
                                    method: "GET",
                                    statusCodeFuncs: {
                                        200: function (response) {

                                            var items = response.Items ? response.Items : response;

                                            if (r.AuthInfo.ServerTimeMatchesUTC === false) {
                                                cafm.msg.showMessageInWindow({

                                                    type: cafm.enums.MessageType.Warning,
                                                    title: 'WARNING',
                                                    text: cafm.res.str.AuthMessageSqlServerTimeDoesNotAppearToMatchUtc,
                                                    onClose() {
                                                        cafm.auth.checkListOfTimezones(items);
                                                    }
                                                });
                                            }
                                            else {
                                                $('#loginForm').fadeOut();
                                                cafm.auth.checkListOfTimezones(items);
                                            }
                                        }
                                    },
                                    error: function (response) {
                                        console.error('error on keep alive')
                                    }
                                });
                            break;

                        case cafm.enums.LoginStatus.FailurePasswordExpired:

                            cafm.auth.setAuthenticationInfo(r.AuthInfo);
                            cafm.cache.set(cafm.res.consts.CacheKey_PasswordExpired, true);
                            a.showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.AuthMessagePasswordExpired });

                            setTimeout(function () {

                                cafm.auth.showChangePassword();
                            }, 2000);
                            break;

                        case cafm.enums.LoginStatus.FailurePasswordTooSimple:

                            cafm.auth.setAuthenticationInfo(r.AuthInfo);
                            cafm.cache.set(cafm.res.consts.CacheKey_PasswordTooSimple, true);
                            a.showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.AuthMessagePasswordInvalid });

                            setTimeout(function () {

                                cafm.auth.showChangePassword();
                            }, 2000);
                            break;

                        default:

                            a.showMessage({ Type: cafm.enums.MessageType.Error, Title: cafm.res.str.AuthMessageLoginFailed });
                            break;
                    }
                },
                401: function (r, s, m, a) {

                    if (cafm.auth.mode == cafm.enums.CAFMAuthenticationMode.Forms) {

                        $('#loginForm').getViewModel().set('Password', '');
                        $('#password').focus();
                        a.showMessage({ Type: cafm.enums.MessageType.Error, Title: cafm.res.str.AuthMessageLoginFailed });
                        a.hideLoader();
                    }
                }
            }
        });
    },
    /// <field name='forgottenPasswordAction' type='cafm.actions.Action'>The forms forgotten password action</field>
    forgottenPasswordAction: function () {

        return new cafm.actions.Action({
            id: 'ForgottenPassword',
            elementId: 'forgottenPwdForm',
            loaderSelector: '#forgottenPwdBtn',
            url: cafm.url.api('Login/ForgottenPassword'),
            preventValidationMessage: true,
            statusCodeFuncs: {
                200: function (r, s, m, a) {

                    a.showMessage({
                        Title: cafm.res.str.MessageEmailSent,
                        Type: cafm.enums.MessageType.Success
                    });
                    $('#forgottenPwdBtn').hide();
                }
            }
        })
    },
    /// <field name='logoutAction' type='cafm.actions.Action'>The forms logout action</field>
    logoutAction: function () {

        return new cafm.actions.Action({
            id: 'CAFMLogout',
            description: 'CAFM Logout',
            url: cafm.url.api('Login/Logout'),
            method: 'GET',
            usesInPlaceLoader: true,
            loaderSelector: '.logout',
            complete: (response) => {

                // execute any log out handlers that have been registered
                cafm.handlers.exe('cafm.logout');

                // redirect
                if (cafm.auth.mode == cafm.enums.CAFMAuthenticationMode.Forms) {

                    window.location = cafm.url.get();
                }
            }
        });
    },
    /// <field name='changePasswordAction' type='cafm.actions.Action'>The forms change password action</field>
    changePasswordAction: function () {

        return new cafm.actions.Action({
            id: 'ChangePassword',
            description: 'Change Password',
            elementId: 'changePassword',
            url: cafm.url.api('Login/ChangePassword'),
            loaderSelector: '#changePwd',
            preventValidationMessage: true,
            validate: function (a) {
                var vm = a.getElement().getViewModel();
                if (vm.NewPassword != vm.ConfirmPassword) {
                    a.set({ 'valid': false });
                    a.set({ 'validationMessage': cafm.res.str.AuthMessagePasswordMismatch });
                }
                else if (vm.OldPassword == vm.NewPassword) {
                    a.set({ 'valid': false });
                    a.set({ 'validationMessage': cafm.res.str.AuthMessageNewPasswordSame });
                }
            },
            statusCodeFuncs: {
                200: function (r, s, m, a) {
                    cafm.cache.remove(cafm.res.consts.CacheKey_PasswordExpired);
                    cafm.cache.remove(cafm.res.consts.CacheKey_PasswordTooSimple);
                    a.showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.AuthMessagePasswordChanged });
                    setTimeout(function () {
                        window.location = cafm.url.get();
                    }, 5000);
                }
            }
        });
    },
    init: function () {
        /// <summary>Initialises the authentication actions and events. Also ensures the user is authenticated when called</summary>

        var cs = cafm.getClientSettings();

        if (cafm.auth.mode == cafm.enums.CAFMAuthenticationMode.Forms || cs.enableWindowsLogout) {

            $('#signOut').bind('click', function (e) {
                return cafm.auth.logout();
            });

        }

        // check for forms password expired flag in cache
        // also make sure we are not on an authentication page
        if (cafm.auth.mode == cafm.enums.CAFMAuthenticationMode.Forms &&
            (cafm.cache.exists(cafm.res.consts.CacheKey_PasswordExpired) || cafm.cache.exists(cafm.res.consts.CacheKey_PasswordTooSimple)) &&
            !cafm.nav.isNav(cafm.enums.Navigatable.AuthenticationChangePassword, cafm.enums.Navigatable.AuthenticationLogin, cafm.enums.Navigatable.AuthenticationForgottenPassword)) {

            // show change password view
            cafm.auth.showChangePassword();
        }
    },
    getLoginInfo: function () {
        /// <summary>Gets the cached login info object for the current user</summary>
        /// <returns type="Object">The login object</returns>

        if (!cafm.auth._loginInfo) {

            cafm.auth._loginInfo = cafm.cache.get(cafm.res.consts.CacheKey_LoginInfo);
        }
        return cafm.auth._loginInfo;
    },
    personId: function () {

        var li = cafm.auth.getLoginInfo();
        return li ? li.pid : cafm.guid.empty;
    },
    personName: function () {

        var li = cafm.auth.getLoginInfo();
        return li ? li.name : '';
    },
    userDescription: function () {

        var li = cafm.auth.getLoginInfo();
        return li ? li.userDescription : '';
    },
    personEmail: function () {

        var li = cafm.auth.getLoginInfo();
        return li ? li.email : '';
    },
    companyId: function () {

        var li = cafm.auth.getLoginInfo();
        return li ? li.comId : cafm.guid.empty;
    },
    companyName: function () {

        var li = cafm.auth.getLoginInfo();
        return li ? li.comName : cafm.guid.empty;
    },
    isGuest: function () {

        var li = cafm.auth.getLoginInfo();
        return li && li.user.toLowerCase() == 'guest';
    },
    isAnonGuest: function () {

        var li = cafm.auth.getLoginInfo();
        return li && li.user.toLowerCase() == 'guest' && li.pid == cafm.guid.empty;
    },
    isPublic: function () {

        var li = cafm.auth.getLoginInfo();
        return li && li.sysLogin;
    },
    logout: function () {

        cafm.cache.remove(cafm.res.consts.CacheKey_LastTimeZoneSelection);

        if (cafm.enums.isSingleEnumValue(cafm.auth.mode, [cafm.enums.CAFMAuthenticationMode.ADFS, cafm.enums.CAFMAuthenticationMode.Azure, cafm.enums.CAFMAuthenticationMode.Windows])) {
            return true;
        }
        cafm.auth.logoutAction().execute();

        if (cafm.isOfflineEnabled()) {
            cafm.offline.uregisterServiceWorker();
        }

        return false;
    },
    showChangePassword: function () {
        /// <summary>Shows the change password panel</summary>

        window.location = cafm.url.get('Authentication/ChangePassword');
    },
    prepareLogin: function () {
        /// <summary>Prepares the forms login panel</summary>

        var loginInfo = cafm.auth.getLoginInfo();
        var la = cafm.auth.loginAction();
        var lfc = $('#loginForm');

        loginInfo = loginInfo && loginInfo.rem ? {
            Username: loginInfo ? loginInfo.user : '',
            Persist: loginInfo ? loginInfo.rem : false
        } : {
                Username: '',
                Persist: false
            };

        lfc.bindViewModel({
            viewModel: loginInfo,
            action: la,
            targPnl: lfc
        });

        if (loginInfo && loginInfo.rem && loginInfo.user) {

            $('#password').focus();
        }
        else {

            $('#username').focus();
        }

        $('#username,#password').enterPressed(function (e) {

            $('#username,#password').blur();
            $('#signIn').click();
            return false;
        });

        $('#password').checkForCapsLock(function () {

            if (isUndefined(la.capsMsgShown)) {
                la.showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.MessageCapsLock });
                la.capsMsgShown = true;
            }
        }, function () {

            if (la.capsMsgShown) {
                delete la.capsMsgShown;
                la.hideMessage();
            }
        });

        // check this is within an iframe, if so post a message to inform the parent, if the parent is CAFM Web then the user will be redirected, if appropriate
        if (isInIframe()) {
            parent.postMessage({
                command: "FrameLogin"
            });
        }

        lfc.prepareForm().fadeIn();

        $('#forgottenPwdLink').click(function () {
            var un = $('#username').val();
            cafm.cache.set(cafm.res.consts.CacheKey_UserNameEntered, un ? un : '');
            window.location = cafm.url.get('Authentication/ForgottenPassword');
        });
    },
    prepareChangePwd: function (password, loginInfo) {
        /// <summary>Prepares the forms change password panel</summary>
        /// <param name="password" type="String">The existing password</param>
        /// <param name="loginInfo" type="Object">Login info to set after the change password operation</param>

        var changePwdForm = $('#changePassword');
        var cpa = cafm.auth.changePasswordAction();

        $('#oldPassword,#newPassword,#confirmPassword').checkForCapsLock(function () {

            if (isUndefined(cpa.capsMsgShown)) {

                cpa.showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.MessageCapsLock });
                cpa.capsMsgShown = true;
            }
        }, function () {

            if (cpa.capsMsgShown) {

                delete cpa.capsMsgShown;
                cpa.hideMessage();
            }
        });

        $('#oldPassword,#newPassword,#confirmPassword').enterPressed(function (e) {

            $('#oldPassword,#newPassword,#confirmPassword').blur();
            $('#changePwd').click();
            return false;
        });

        var vm = {};

        if (password) {

            vm.OldPassword = password;
            $('.cfField:first', changePwdForm).hide();
        }

        changePwdForm.bindViewModel({
            viewModel: vm,
            action: cpa,
            targPnl: changePwdForm
        });

        if (!password) {

            if (cafm.cache.exists(cafm.res.consts.CacheKey_PasswordExpired)) {

                cpa.showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.AuthMessagePasswordExpired });
            }
            else if (cafm.cache.exists(cafm.res.consts.CacheKey_PasswordTooSimple)) {

                cpa.showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.AuthMessagePasswordTooSimple });
            }
        }

        if (loginInfo) {

            cafm.auth.setAuthenticationInfo(loginInfo, false);
        }

        changePwdForm.prepareForm().fadeIn();
    },
    prepareForgottenPwd: function () {
        /// <summary>Shows the forms forgotten password panel</summary>

        var loginInfo = cafm.auth.getLoginInfo();

        var vmUsername = '';

        var unEntered = cafm.cache.get(cafm.res.consts.CacheKey_UserNameEntered);
        if (unEntered && unEntered.length > 0) {
            vmUsername = unEntered;
        }
        else if (loginInfo && loginInfo.user) {
            vmUsername = loginInfo.user;
        }

        var vmEmail = (loginInfo && loginInfo.email) ? loginInfo.email : '';

        var vm = {
            Username: vmUsername,
            Email: vmEmail
        };

        var targ = $('#forgottenPwdForm');
        targ.bindViewModel({
            viewModel: vm,
            action: cafm.auth.forgottenPasswordAction(),
            targPnl: targ
        }).fadeIn();

        $('#username,#email').enterPressed(function (e) {

            var btn = $('#forgottenPwdBtn');
            if (btn.is(":visible")) {
                $('#username,#email').blur();
                $('#forgottenPwdBtn').click();
            }
            return false;
        });
    },

    notAuthenticated: function () {
        /// <summary>Call this method when the user is not authenticated to show a forms login box or attempt to login if windows or username authenticated</summary>

        // if forms or username authentication and an authenticated URL
        if ((cafm.auth.mode == cafm.enums.CAFMAuthenticationMode.Forms || cafm.auth.mode == cafm.enums.CAFMAuthenticationMode.Username) && cafm.url.isAuthenticatedUrl()) {

            window.location = cafm.url.get('{0}?returnurl={1}'.format(cafm.auth.loginPath, encodeURI(window.location.pathname + window.location.search + window.location.hash)));
        }
        else if (cafm.auth.mode == cafm.enums.CAFMAuthenticationMode.ADFS || cafm.auth.mode == cafm.enums.CAFMAuthenticationMode.Azure) {

            window.location.reload(true);
        }
    },

    setAuthenticationInfo: function (inf, redirecting, rem) {
        /// <summary>Performs some actions after successful forms authentication</summary>
        /// <param name="inf" type="Object">Authentication info object</param>
        /// <param name="redirecting" type="Boolean">Is login being redirected?</param>
        /// <param name="rem" type="Boolean">Remember username?</param>

        var li = cafm.auth.getLoginInfo();
        var clearCache = li && (li.user != inf.UserName || li.pid != inf.PersonId);
        // TODO: consider changing the javascript to not convert the DTO and just use the server DTO and its property names
        li = {
            user: inf.UserName,
            userDescription: inf.UserDescription,
            pid: inf.PersonId,
            apiKey: inf.ApiKey,
            name: inf.PersonName,
            email: inf.Email,
            comId: inf.CompanyId,
            comName: inf.CompanyName,
            rem: cafm.util.isTrue(rem),
            sysLogin: inf.IsSystemLogin
        };

        // cache user info
        cafm.cache.set(cafm.res.consts.CacheKey_LoginInfo, li);
        cafm.auth._loginInfo = li;

        // fire on logged in handler
        cafm.web.onUserLoggedIn(redirecting, clearCache);
    },

    checkListOfTimezones: function (items) {
        cafm.util.callFunctionAsync({
            func() {
                if (items.length > 1) {
                    window.location = cafm.url.get('TimeZone/ChangeTimeZone');
                }
                else {
                    //set TimeZone name in the session
                    cafm.timezone.cacheTimeZone(items[0].Name);

                    //save the session time zone
                    cafm.timezone.saveSessionTimeZone(items[0].Name);

                    //remove authenticationtimezone class
                    document.body.className = document.body.className.replace("authenticationtimezone", "desktop dashboard");
                }
                //Cach for future use
                cafm.cache.set(cafm.res.consts.CacheKey_UserTimeZones, items);
                
            },
            timeout: 1000
        });
    }
}